import { WebSite, WithContext } from 'schema-dts';
import { GeigerLocale } from '~/utility/i18n';

/**
 * Generates Website JSON-LD schema for Geiger Gruppe website
 * @param locale Current locale for language-specific data
 * @param baseUrl Base URL of the website
 * @returns Website schema object
 */
export function generateWebsiteSchema(locale: GeigerLocale): WithContext<WebSite> {
  const names: Record<GeigerLocale, string> = {
    'de-de': 'Geiger Gruppe - Nachhaltiges Bauen & Kreislaufwirtschaft',
    'at-de': 'Geiger Gruppe - Nachhaltiges Bauen & Kreislaufwirtschaft',
    'it-it': 'Gruppo Geiger - Edilizia Sostenibile & Economia Circolare',
    'ro-ro': 'Grupul Geiger - Construcții Durabile & Economie Circulară',
  };
  return {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: names[locale],
    url: 'https://www.geigergruppe.com',
    publisher: {
      '@type': 'Organization',
      name: 'Geiger Gruppe',
    },
    inLanguage: Object.values(GeigerLocale),
  };
}
